import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from "reactstrap";
// componentes
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";

export default function ModalEditStatus(props) {
  const options = [
    "Programado",
    "Embarcando",
    "Em Trânsito",
    "Finalizado",
    "Cancelado",
  ];

  const { isOpen, toggle, changeStatus, data } = props;
  const [isLoading, setIsloading] = useState(false);
  // valor do campo
  const [selected, setSelected] = useState(
    data?.status
      ? {
          label: data.status,
          value: data.status,
        }
      : {}
  );
  const [notes, setNotes] = useState(null);
  //   alerta
  const [notesError, setNotesError] = useState(null);
  const [success, setSuccess] = useState(false);
  const handleChangeStatus = (newStatus, notes) => {
    changeStatus(newStatus, notes);
  };

  function renderOptions(activeStatus) {
    return (
      <>
        {options.map((item) => (
          <option key={item} value={item} selected={item === activeStatus}>
            {item}
          </option>
        ))}
      </>
    );
  }

  return (
    <>
      {success && (
        <SweetAlert
          success
          title={"Atualizado"}
          onConfirm={() => {
            setSuccess(false);
            toggle();
          }}
        >
          {"Status atualizado com sucesso!"}
        </SweetAlert>
      )}

      <Modal isOpen={isOpen} centered autoFocus>
        <ModalHeader toggle={toggle}>Alterar Status</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <label className="form-label">Status *</label>
              {/* <select
                className="form-control"
                onChange={(e) => setSelected(e.target.value)}
              >
                {data?.status ? renderOptions(data.status) : <></>}
              </select> */}

              <Select
                placeholder={"Selecione"}
                onChange={(e) => {
                  setSelected(e);
                }}
                value={selected}
                options={[
                  {
                    options: options.map((e) => ({
                      label: e,
                      value: e,
                    })),
                  },
                ]}
                classNamePrefix="select2-selection"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                    overflowY: "auto",
                  }),
                }}
              />
            </Col>
          </Row>

          {selected.value === "Cancelado" && (
            <Row style={{ marginTop: 10 }}>
              <Col md={12}>
                <label className="form-label">Justificativa *</label>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => setNotes(e.target.value)}
                />
              </Col>
              {notesError && <a style={{ color: "red" }}>{notesError}</a>}
            </Row>
          )}

          <Row
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <Button
              color="danger"
              style={{ width: 80 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>

            <ButtonSpinner
              isLoading={isLoading}
              title={"Salvar"}
              isDisabled={!selected.value || selected.value === data?.status}
              marginLeft={10}
              action="U"
              onClick={() => {
                if (!notes && selected.value === "Cancelado") {
                  setNotesError("O campo Justificativa é obrigatório");
                  return;
                }
                handleChangeStatus(selected.value, notes);
                setSuccess(true);
              }}
            />
          </Row>
        </ModalBody>
      </Modal>
    </>
  );
}
